import React, { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import Navbar from "../components/Navbar.component";
import Footer from "../components/Footer.component";

const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");

  const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    try {
      const response = await axios.post(
        "https://staging.drugstoc.com/api/v2/auth/password_reset/",
        {
          email,
        }
      );
      setMessage(
        `Email Reset Successfully. ${response.data.status.toUpperCase()}.`
      );
    } catch (err: any) {
      setError(err.message);
    }
  };
  const navigate = useNavigate();
  const onClick = () => {
    navigate("/login/forgot-password/sent");
  };
  return (
    <>
      <Navbar />
      <div>
        <h1>Request Password Reset</h1>
        <form
          // accept-charset="UTF-8"
          // action="/login/forgot-password"
          // method="post"
          onSubmit={handleSubmit}
        >
          <label>
            Please enter your email:
            <div>
              <input
                type="email"
                value={email}
                onChange={(event) => setEmail(event.target.value)}
              />
            </div>
          </label>
          <div>
            <button onClick={onClick} type="submit">
              Request Password Reset
            </button>
          </div>
        </form>
        {message && <p style={{ color: "green" }}>{message}</p>}
        {error && <p style={{ color: "red" }}>{error}</p>}
      </div>
      <Footer />
    </>
  );
};

export default ForgotPassword;
